import { getRecurringPaymentsList } from '../../api/paymentApi';

const GET_PAYMENTS_LIST = 'efes/paymentsList/GET_PAYMENTS_LIST';
const GET_PAYMENTS_LIST_SUCCESS = 'efes/paymentsList/GET_PAYMENTS_LIST_SUCCESS';
const GET_PAYMENTS_LIST_FAIL = 'efes/paymentsList/GET_PAYMENTS_LIST_FAIL';

const initialState = {
  payments: { data: [], total: 0 },
  isLoading: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PAYMENTS_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_PAYMENTS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        payments: action.result,
      };
    case GET_PAYMENTS_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export function getPayments({ params, filters }) {
  return {
    actions: [
      { type: GET_PAYMENTS_LIST },
      { type: GET_PAYMENTS_LIST_SUCCESS },
      { type: GET_PAYMENTS_LIST_FAIL, showError: true },
    ],
    promise: getRecurringPaymentsList(params, filters),
  };
}
